export const CACHE_KEYS = {
  CATEGORIES: 'categories',
  CATEGORY_GROUPS: 'categoryGroups',
  TAGS: 'householdTransactionTags',
};
